import React, { useState, useEffect } from "react";
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import { db } from "../firebaseConfig";
import { UserAuth } from "../context/authContext";

const Room = ({ roomId }) => {
  const [roomData, setRoomData] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const { user } = UserAuth();

  useEffect(() => {
    const unsubscribe = db
      .collection("rooms")
      .doc(roomId)
      .onSnapshot((snapshot) => {
        if (snapshot.exists) {
          setRoomData(snapshot.data());
        } else {
          setErrorMessage("Room not found. Please enter a valid room ID.");
        }
      });

    return () => unsubscribe();
  }, [roomId]);

  const handleLeaveRoom = async () => {
    try {
      // Remove the current user from the room
      await db
        .collection("rooms")
        .doc(roomId)
        .update({
          users: firebase.firestore.FieldValue.arrayRemove(user.email),
        });
      // Optionally, redirect the user to another page after leaving the room
    } catch (error) {
      console.error("Error leaving room:", error);
      setErrorMessage("Failed to leave room. Please try again later.");
    }
  };

  return (
    <div className="max-w-md mx-auto mt-8 p-6 bg-white rounded-lg shadow-md">
      <h1 className="text-2xl font-bold mb-4">Room</h1>
      {errorMessage && <p className="text-red-500 mt-2">{errorMessage}</p>}
      {roomData && (
        <div>
          <h2 className="text-lg font-semibold mb-2">Users in the Room:</h2>
          <ul>
            {roomData.miner && roomData.miner.map((email) => <li key={email}>{email} - Miner</li>)}
            {roomData.user && roomData.user.map((email) => <li key={email}>{email} - User</li>)}
          </ul>
        </div>
      )}
      <button
        onClick={handleLeaveRoom}
        className="bg-red-500 text-white font-semibold px-4 py-2 rounded-md"
      >
        Leave Room
      </button>
    </div>
  );
};

export default Room;
